import { render, staticRenderFns } from "./list.vue?vue&type=template&id=cf3c464e&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=cf3c464e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3c464e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf3c464e')) {
      api.createRecord('cf3c464e', component.options)
    } else {
      api.reload('cf3c464e', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=cf3c464e&scoped=true", function () {
      api.rerender('cf3c464e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/commodityManagement/servingManagement/list.vue"
export default component.exports